export default "__VITE_ASSET__745c32a9__"